import SearchResult from '@/core/search/SearchResult';

export default class ProjectListSearchResult extends SearchResult {
}
